import useClientBillView from '@/features/dashboard/bookingChanges/hooks/useClientBillView.ts';
import {
  ClientBillView,
  ClientBillViewSkeleton,
} from '@/features/dashboard/bookingChanges/components/bill';
import EmbeddedBillEmpty from './EmbeddedBillEmpty';
import { EmbeddedBillProps, embeddedSkeletonClass } from './embeddedBill';

/** Treść rozwiniętego kafla zapisującego — ten sam komponent, co ekran B. */
const EmbeddedClientBill = ({
  bookingId,
  bookingCode,
  isEditing,
  onOpenBooking,
  onRowAction,
  ...props
}: EmbeddedBillProps) => {
  const { view, isLoading } = useClientBillView(bookingId);

  if (isLoading) {
    return (
      <ClientBillViewSkeleton className={embeddedSkeletonClass} {...props} />
    );
  }

  if (!view) {
    return (
      <EmbeddedBillEmpty
        title="Brak danych zapisującego"
        description="Ta rezerwacja nie ma jeszcze przypisanej osoby zapisującej."
        {...props}
      />
    );
  }

  return (
    <ClientBillView
      embedded
      data={view}
      isEditing={isEditing}
      onRowAction={onRowAction}
      onOpenBooking={onOpenBooking}
      bookingCode={bookingCode}
      {...props}
    />
  );
};

export default EmbeddedClientBill;
